


















import Vue from "vue";
import Component from "vue-class-component";
import {Location} from "vue-router";
import {Prop} from "vue-property-decorator";
import {User} from "@teacherskaya/api-provider/dist/api/UserProvider";
import {Dictionary} from "@teacherskaya/api-provider/dist/api/types";
import {TableItem, TableItems} from "@/types";
import config from "@/config";
import {Time} from "@/lib/helpers";
import {TEXT} from "@/lib/const";
import {$t} from "@/lib/helpers/i18nHelper";
import BaseTable from "@/components/BaseTable.vue";

@Component({ name: "UserListTable", components: { BaseTable } })
export default class UserListTable extends Vue {
  @Prop({ type: Array })
  public readonly userData!: User[];

  @Prop({ type: Object, required: true })
  public readonly balance!: Dictionary<number>;

  public get hasPhone() {
    return config.featurePhoneSignUp;
  }

  public get items(): TableItems {
    const result: TableItems = [];
    this.userData.forEach(user => {
      result.push({
        id: user.id,
        email: user.email,
        role: $t(user.role ?? ""),
        phone: user.phone,
        screenName: this.getUserScreenName(user),
        registered: Time.formatDate(user.accountInfo.registrationTime),
        lastVisited: user.accountInfo.lastLoginTime
          ? Time.dateFromNow(user.accountInfo.lastLoginTime)
          : TEXT.FIELD_EMPTY,
      });
    });
    return result;
  }

  public get profileLink() {
    return (row: TableItem): Location => {
      const userId = row.id ? row.id.toString() : "";
      return {
        name: "profile",
        params: { userId },
      };
    };
  }

  public getUserScreenName(user: User) {
    return user.accountInfo.disabled ? `${user.screenName} DISABLED` : user.screenName;
  }
}
